export default __webpack_public_path__ + "static/media/mtt_popescucozmin.3df3a22d.jpg";